import config from 'config';
import { useUpdateData } from '@tiimiit/hooks';
import { UseUpdateResult } from '@tiimiit/hooks/lib/use-update-data';
import { useAppContext } from '../../context/appContext';
import { useKeycloak } from '../../auth/keycloak';

const url: string = config.api.url;

type UsePutRequestProps = {
  path: string;
  headers?: unknown;
};
export function usePutRequest<Result = unknown>({ path, headers }: UsePutRequestProps): UseUpdateResult<Result> {
  const {
    settings: { issuer, routeIssuer },
  } = useAppContext();
  const { keycloak } = useKeycloak();

  keycloak
    .updateToken(5)
    .then(() => {
      localStorage.setItem('kc_token', keycloak.token);
      localStorage.setItem('kc_refreshToken', keycloak.refreshToken);
    })
    .catch(() => keycloak.login());
  return useUpdateData<Result>({
    url,
    path,
    // @ts-ignore
    headers: { ...headers, 'X-Prisma-Issuer': issuer?.name, Authorization: `Bearer ${keycloak.token}`, 'backoffice-source': routeIssuer  },
  });
}

export default usePutRequest;